import { z } from "zod";

export const accountReqSchema = z.object({
  payoutsPage: z.coerce.number().min(1).default(1),
  payoutsPageSize: z.coerce.number().min(1).max(100).default(25),
});
